import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import shipCore from "../core/ship.core";

export default function useHKDistricts() {
  const { locale, isReady } = useRouter();
  return useQuery({
    queryKey: ["hkSubDistricts", locale],
    queryFn: shipCore.getHkSubDistricts,
    enabled: isReady,
  });
}
